import base from './base'
const baseURL = process.env.VUE_APP_API_BASE_URL || '/api'
import { getDeviceType } from './http'

export default {

  // 获取话题列表
  getTopicList(params) {
    return base.get('/chat/Chat/getTopicList', params)
  },

  // 修改话题
  updateTopic(params) {
    return base.post('/chat/Chat/updateTopic', params)
  },

  // 删除话题
  deleteTopic(params) {
    return base.post('/chat/Chat/delete', params)
  },

  // 获取指定问答内容
  getTopicContent(params) {
    return base.get('/chat/Chat/getTopicContent', params)
  },

  // 获取引导话题
  getPromptList(params) {
    return base.get('/chat/Prompt/getList', params)
  },

  // 流式会话接口
  async streamChat(params) {
    const response = await fetch(`${baseURL}/chat/Chat/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'XX-Api-Version': '1.0', // 固定值
        'Accept-Language': 'zh-cn', // 默认值
        'XX-Device-Type': getDeviceType(),
        'XX-Token': localStorage.getItem('authToken') || ''
      },
      body: JSON.stringify(params)
    })

    return response
  }
}
